import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import styled from "styled-components";
import OrderServices from "../based/services/OrderServices";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";
import VideoModal from "./VideoModal";
const DomainAPI = process.env.NODE_ENV === "production" ? "https://192.168.199.249:6002" : "https://localhost:6002";
import VideoIcon from "./assets/VideoIcon.svg";
import TFUSelect from "../based/inputs/TFUSelect";

function CameraSection({ orderId }, ref) {
    const [devices, setDevices] = useState([]);
    const [isRecording, setIsRecording] = useState(false);
    const [isPause, setIsPause] = useState(false);
    const [recordingTime, setRecordingTime] = useState(0);
    const [recordingInterval, setRecordingInterval] = useState(null);
    const regexSets = new Map();

    //ds video url
    const [packageVideos, setPackageVideos] = useState([]);
    const [videoUrl, setVideoUrl] = useState(null);

    useImperativeHandle(ref, () => ({
        handleStartRecord,
        handleStopRecord,
        getDevices: () => devices,
    }));

    useEffect(() => {
        navigator.mediaDevices.enumerateDevices().then((deviceInfos) => {
            const videoDevices = deviceInfos.filter((device) => device.kind === "videoinput");
            setDevices(videoDevices);
        });
    }, []);

    useEffect(() => {
        if (orderId) {
            getPackageVideos(orderId);
        }
    }, [orderId]);

    useEffect(() => {
        //handle keyboard event, khi nhấn phím C đơn thì capture, không thì thôi
        const handleKeyDown = (event) => {
            //control key
            if (event.key === "Alt" || event.key === "alt") {
                handleCapture();
                event.preventDefault();
                event.stopPropagation();
            } else if (event.key === "Tab" || event.key === "tab") {
                handleStopRecord();
                event.preventDefault();
                event.stopPropagation();
            } else if (event.key === " ") {
                handlePauseRecord();
                event.preventDefault();
                event.stopPropagation();
            } else {
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [regexSets, isRecording, isPause]);

    const handleStartRecord = () => {
        setIsRecording(true);
        setRecordingTime(0);
        setRecordingInterval(
            setInterval(() => {
                setRecordingTime((prev) => prev + 1);
            }, 1000)
        );
        regexSets.forEach((item) => {
            if (item && item.startRecord) item.startRecord();
        });
    };

    const handleStopRecord = () => {
        regexSets.forEach((item) => {
            if (item && item.stopRecord) item.stopRecord();
        });
        clearInterval(recordingInterval);
        setRecordingInterval(null);
        setRecordingTime(0);
        setIsPause(false);
        setIsRecording(false);
    };

    const handlePauseRecord = () => {
        //pause thiết bị
        regexSets.forEach((item) => {
            if (item && item.pauseRecord) item.pauseRecord();
        });

        //config pause
        let currentPause = !isPause;
        setIsPause(currentPause);

        //nếu đang pase thì stop, clear interval
        if (currentPause) {
            clearInterval(recordingInterval);
            setRecordingInterval(null);
        } else {
            setRecordingInterval(
                setInterval(() => {
                    setRecordingTime((prev) => prev + 1);
                }, 1000)
            );
        }
    };

    const handleCapture = () => {
        regexSets.forEach((item) => {
            if (item && item.capture) item.capture();
        });
    };

    const getPackageVideos = async (orderId) => {
        const [err, data] = await OrderServices.GetListOrderPackageModel(orderId);
        if (!err && data) {
            setPackageVideos(data);
        } else {
            setPackageVideos([]);
        }
    };

    const handleUploadVideo = async (videoUrl) => {
        const [err, data] = await OrderServices.CreateUpdateListOrderPackageModel([
            {
                orderId: orderId,
                url: videoUrl,
            },
        ]);
        if (!err && data) {
            getPackageVideos(orderId);
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra trong quá trình upload video");
        }
    };

    const handleRemove = async (id) => {
        const [err, data] = await OrderServices.RemoveOrderPackage(id);
        if (!err && data) {
            getPackageVideos(orderId);
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra trong quá trình upload video");
        }
    };

    return (
        <React.Fragment>
            <CameraWrapper>
                <section className="camera-info">
                    <div className="list-camera">
                        {devices && devices.length > 0 ? (
                            devices.map((device, index) => {
                                return (
                                    <CameraItem
                                        id={`record-video-${index}`}
                                        deviceId={device.deviceId}
                                        ref={(e) => {
                                            regexSets.set(device.deviceId, e);
                                        }}
                                        onSave={(videoUrl) => {
                                            if (videoUrl) handleUploadVideo(videoUrl);
                                        }}
                                        orderId={orderId}
                                        label={device.label}
                                        lstLength={packageVideos ? packageVideos.length : 0}
                                    />
                                );
                            })
                        ) : (
                            <div className="no-data text-center">Không phát hiện Camera</div>
                        )}
                    </div>
                    <div className="video-button">
                        <div className="lst-button">
                            {!isRecording ? (
                                <button
                                    className="btn btn-custom m-2"
                                    onClick={(e) => {
                                        handleStartRecord();
                                    }}
                                >
                                    Quay Video
                                </button>
                            ) : (
                                <>
                                    {isPause ? (
                                        <button
                                            className="btn btn-custom m-2"
                                            onClick={(e) => {
                                                handlePauseRecord();
                                            }}
                                        >
                                            Tiếp tục
                                            <small>(Space)</small>
                                        </button>
                                    ) : (
                                        <button
                                            className="btn btn-danger m-2"
                                            onClick={(e) => {
                                                handlePauseRecord();
                                            }}
                                        >
                                            Tạm dừng
                                            <small>(Space)</small>
                                        </button>
                                    )}

                                    <button
                                        className="btn btn-danger m-2"
                                        onClick={(e) => {
                                            handleStopRecord();
                                        }}
                                    >
                                        Kết thúc
                                        <small>(Tab)</small>
                                    </button>
                                </>
                            )}

                            <button
                                className="btn btn-orange m-2"
                                onClick={(e) => {
                                    handleCapture();
                                }}
                            >
                                Chụp <small>(Alt)</small>
                            </button>
                        </div>
                        <div className="record-time m-2">
                            <span>{isRecording ? `Đang quay...` : ""}</span>
                            <span className="time">
                                {isRecording
                                    ? `${Math.floor(recordingTime / 60)
                                          .toString()
                                          .padStart(2, "0")}:${(recordingTime % 60).toString().padStart(2, "0")}`
                                    : ""}
                            </span>
                        </div>
                    </div>
                    <div className="lst-video-thumbnail">
                        {packageVideos && packageVideos.length > 0
                            ? packageVideos.map((item, index) => {
                                  let isVideo = item.url.endsWith(".mp4") || item.url.endsWith(".webm");
                                  return (
                                      <div
                                          className="thumbnail cursor-pointer"
                                          key={index}
                                          onClick={(e) => {
                                              setVideoUrl(item.url);
                                          }}
                                      >
                                          {isVideo ? (
                                              <>
                                                  <video src={item.url} alt="" />
                                                  <div className="icon">
                                                      <img src={VideoIcon} alt="" />
                                                  </div>
                                              </>
                                          ) : (
                                              <img src={item.url} alt="" />
                                          )}
                                          <div
                                              className="remove-icon cursor-pointer"
                                              onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleRemove(item.id);
                                              }}
                                          >
                                              <i className="fa fa-remove"></i>
                                          </div>
                                      </div>
                                  );
                              })
                            : null}
                    </div>
                </section>
            </CameraWrapper>
            <VideoModal
                show={videoUrl ? true : false}
                onClose={() => {
                    setVideoUrl(null);
                }}
                videoUrl={videoUrl}
            />
        </React.Fragment>
    );
}

export default forwardRef(CameraSection);

const CameraItem = forwardRef(({ id, deviceId, orderId, isPause, onSave, lstLength }, ref) => {
    useImperativeHandle(ref, () => ({
        startRecord: handleStartRecord,
        stopRecord: handleStopRecord,
        pauseRecord: handlePauseRecord,
        capture: handleCapture,
    }));

    const videoRef = useRef(null);
    const streamRef = useRef(null);
    const chunksRef = useRef([]);
    const mediaRecorderRef = useRef(null);
    const [cameraLabelOptions, setCameraLabelOptions] = useState([
        {
            value: "top",
            label: "Top",
        },
        {
            value: "side",
            label: "Side",
        },
    ]);
    const [selectLabel, setSelectLabel] = useState(null);

    useEffect(() => {
        navigator.mediaDevices
            .getUserMedia({ video: { deviceId: { exact: deviceId } } })
            .then((stream) => {
                videoRef.current.srcObject = stream;
                streamRef.current = stream;
            })
            .catch((err) => console.error("Camera error:", err));

        return () => {
            streamRef.current?.getTracks().forEach((t) => t.stop());
        };
    }, [deviceId]);

    useEffect(() => {
        //lấy label từ local storage
        const lb = localStorage.getItem(`camera-label-${deviceId}`);
        if (lb) {
            setSelectLabel(lb);
        } else {
            setSelectLabel("top");
        }
    }, [deviceId]);

    const handleStartRecord = () => {
        chunksRef.current = [];
        const video = document.getElementById(id);
        const recorder = new MediaRecorder(video.srcObject);
        recorder.ondataavailable = function (e) {
            if (e.data.size > 0 && !isPause) {
                chunksRef.current.push(e.data);
                console.log("isPause", isPause);

                //get size of data
                const size = chunksRef.current.reduce((acc, chunk) => acc + chunk.size, 0);
                console.log("size", size);
            }
        };
        recorder.onstop = function () {
            // //data từ chunksRef
            // let dt = chunksRef.current;

            // //nếu size > 100mb thì split ra thành nhiều file rồi upload lên
            // let length = dt.reduce((acc, chunk) => acc + chunk.size, 0);
            // let count = Math.ceil(length / (100 * 1024 * 1024)); //100mb

            // for (let i = 0; i < count; i++) {
            //     //lấy ra chunk từ chunksRef
            //     const start = i * (100 * 1024 * 1024);
            //     const end = start + 100 * 1024 * 1024;
            //     const chunk = dt.slice(start, end);
            //     if (chunk.length > 0) {
            //         //lấy ra size của video
            //         const blob = new Blob(chunk, { type: "video/webm" });
            //         var now = new Date();
            //         const firstCharLabel = selectLabel ? selectLabel.charAt(0).toUpperCase() : "C";
            //         const fileName = `${now.getDay()}${now.getMonth()}${now.getFullYear()}-${orderId}-${firstCharLabel}-${lstLength + 1}-${i + 1}.mp4`;

            //         //update lên local server
            //         fetch(`${DomainAPI}/api/local/receive?fileName=${fileName}`, {
            //             method: "POST",
            //             body: blob,
            //         })
            //             .then((response) => response.json())
            //             .then((data) => {
            //                 console.log("Video uploaded successfully:", data);
            //                 if (data.data && data.data.url) onSave(data.data.url);
            //             })
            //             .catch((error) => {
            //                 console.error("Error uploading video:", error);
            //             });
            //     }
            // }

            //lấy ra size của video
            const blob = new Blob(chunksRef.current, { type: "video/webm" });
            var now = new Date();
            const firstCharLabel = selectLabel ? selectLabel.charAt(0).toUpperCase() : "C";
            const fileName = `${now.getDay()}${now.getMonth()}${now.getFullYear()}-${orderId}-${firstCharLabel}-${lstLength + 1}.mp4`;

            //update lên local server
            fetch(`${DomainAPI}/api/local/receive?fileName=${fileName}`, {
                method: "POST",
                body: blob,
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log("Video uploaded successfully:", data);
                    if (data.data && data.data.url) onSave(data.data.url);
                })
                .catch((error) => {
                    console.error("Error uploading video:", error);
                });

            // download về máy local
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
        };

        recorder.start();
        mediaRecorderRef.current = recorder;
    };

    const handleStopRecord = () => {
        mediaRecorderRef.current?.stop();
    };

    const handlePauseRecord = () => {
        if (mediaRecorderRef.current?.state === "recording") {
            mediaRecorderRef.current.pause();
        } else if (mediaRecorderRef.current?.state === "paused") {
            mediaRecorderRef.current.resume();
        }
    };

    const handleCapture = () => {
        const video = document.getElementById(id);
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext("2d");
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
            //update lên local server
            var now = new Date();
            const firstCharLabel = selectLabel ? selectLabel.charAt(0).toUpperCase() : "C";
            const fileName = `${now.getDay()}${now.getMonth()}${now.getFullYear()}-${orderId}-${firstCharLabel}-${lstLength + 1}.png`;
            fetch(`${DomainAPI}/api/local/receive?fileName=${fileName}`, {
                method: "POST",
                body: blob,
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log("Image uploaded successfully:", data);
                    if (data.data && data.data.url) onSave(data.data.url);
                })
                .catch((error) => {
                    console.error("Error uploading image:", error);
                });

            //download về máy local
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "snapshot.png";
            a.click();
        });
    };

    return (
        <React.Fragment>
            <video id={id} ref={videoRef} autoPlay></video>
            <div className="select-bt">
                <TFUSelect
                    options={cameraLabelOptions}
                    placeholder="Chọn vị trí camera"
                    value={selectLabel}
                    onChanged={(value) => {
                        setSelectLabel(value);

                        //set vào local storage với deviceId
                        localStorage.setItem(`camera-label-${deviceId}`, value);
                    }}
                />
            </div>
        </React.Fragment>
    );
});

const CameraWrapper = styled.div`
    .remove-icon {
        position: absolute;
        top: 10px;
        right: 10px;
    }

    .no-data.text-center {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    button.btn.btn-custom {
        text-wrap: auto;
    }

    .lst-button .btn {
        display: flex;
        flex-direction: column;
    }
    .record-time {
        display: flex;
        flex-direction: column;
    }

    .record-time span {
        color: #28b259;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .record-time span.time {
        font-size: 30px;
        font-weight: 700;
    }
    .thumbnail .icon {
        display: flex;
        position: absolute;
        top: calc(50px - 12px);
        left: calc(50px - 12px);
    }

    .thumbnail {
        position: relative;
    }
    .list-camera video {
        width: 100%;
        padding: 5px;
    }

    .list-camera {
        display: flex;
        flex-direction: column;
    }

    section.camera-info {
        border: 1px solid #f1f1f1;
        background: #fff;
        margin: 10px 0;
        display: flex;
        flex-wrap: wrap;
        padding: 16px;
    }

    .list-camera {
        width: 65%;
    }

    .video-button {
        width: 35%;
    }

    .lst-button {
        display: flex;
        flex-direction: column;
    }

    .btn-orange {
        border: 1px solid #f1f1f1;
        background: #ff9027;
        color: #fff;
        text-align: center;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .btn-custom {
        color: #fff;
        text-align: center;
        font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .lst-video-thumbnail {
        display: flex;
        flex-wrap: wrap;
    }

    .thumbnail {
        width: 100px;
        height: 100px;
        margin: 6px 6px 6px 0;
    }

    .thumbnail img,
    .thumbnail video {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;
